import { useEffect, useState } from 'react';

function CheckboxSelectAllBulk({
  data,
  batchSelectedElements,
  setBatchSelectedElements,
  slice,
  className,
  includeText,
  id,
  cardDataPropName,
  cardDataKey,
}) {
  const [allOnCurrentPageSelected, setAllOnCurrentPageSelected] =
    useState(false);

  useEffect(() => {
    const dataMappedAsKeys = batchSelectedElements?.map((r) => r[cardDataKey]);
    const sliceMappedAsKeys = slice.map(
      (s) => s.props[cardDataPropName][cardDataKey]
    );

    const allElementsOnPageSelected = sliceMappedAsKeys.every((elem) =>
      dataMappedAsKeys?.includes(elem)
    );

    // console.log('Slice mapped as keys:', sliceMappedAsKeys);

    setAllOnCurrentPageSelected(allElementsOnPageSelected);
  }, [slice, batchSelectedElements]);

  return (
    <div className='d-inline-flex gap-2 align-items-center'>
      <input
        id={id}
        type='checkbox'
        checked={
          allOnCurrentPageSelected ||
          data?.length === batchSelectedElements?.length
        }
        className={className}
        onChange={(e) => {
          if (e.target.checked) {
            let newArray = [...batchSelectedElements];

            const sliceAsDataProp = slice.map((e) => e.props[cardDataPropName]);
            let elementsToAdd = sliceAsDataProp.filter(
              (el) =>
                !newArray.some((_el) => _el[cardDataKey] === el[cardDataKey])
            );

            newArray = [...newArray, ...elementsToAdd];

            // TODO: kanske göra om så att man sparar ner hela vehicle objekten och inte bara vehicleId, så att det funkar med denna existerande komponenten

            setBatchSelectedElements(newArray);
          } else {
            let newArray = [...batchSelectedElements];
            const sliceAsDataProp = slice.map((e) => e.props[cardDataPropName]);
            newArray = newArray.filter((r) => !sliceAsDataProp.includes(r));
            setBatchSelectedElements(newArray);
          }
        }}
      />
      {includeText && <label htmlFor={id}>Markera alla</label>}
    </div>
  );
}

export default CheckboxSelectAllBulk;
